/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type GCPRegionsEnum = 'us-west1' | 'us-west2' | 'us-west3' | 'us-west4' | 'us-east1' | 'us-east4' | 'us-east5' | 'us-central1' | 'us-south1' | 'europe-west2' | 'europe-west3' | 'europe-west4' | 'europe-west6' | 'europe-west8' | 'europe-west9' | 'europe-west12' | 'asia-southeast1' | 'us' | 'europe' | 'asia-northeast1' | 'asia-south1' | 'asia-south2' | 'australia-southeast1' | 'me-west1' | 'northamerica-northeast1' | 'northamerica-northeast2' | 'southamerica-east1' | 'southamerica-west1';

export const GCPRegionsEnum = {

    US_WEST1: 'us-west1' as GCPRegionsEnum,

    US_WEST2: 'us-west2' as GCPRegionsEnum,

    US_WEST3: 'us-west3' as GCPRegionsEnum,

    US_WEST4: 'us-west4' as GCPRegionsEnum,

    US_EAST1: 'us-east1' as GCPRegionsEnum,

    US_EAST4: 'us-east4' as GCPRegionsEnum,

    US_EAST5: 'us-east5' as GCPRegionsEnum,

    US_CENTRAL1: 'us-central1' as GCPRegionsEnum,

    US_SOUTH1: 'us-south1' as GCPRegionsEnum,

    EUROPE_WEST2: 'europe-west2' as GCPRegionsEnum,

    EUROPE_WEST3: 'europe-west3' as GCPRegionsEnum,

    EUROPE_WEST4: 'europe-west4' as GCPRegionsEnum,

    EUROPE_WEST6: 'europe-west6' as GCPRegionsEnum,

    EUROPE_WEST8: 'europe-west8' as GCPRegionsEnum,

    EUROPE_WEST9: 'europe-west9' as GCPRegionsEnum,

    EUROPE_WEST12: 'europe-west12' as GCPRegionsEnum,

    ASIA_SOUTHEAST1: 'asia-southeast1' as GCPRegionsEnum,

    US: 'us' as GCPRegionsEnum,

    EUROPE: 'europe' as GCPRegionsEnum,

    ASIA_NORTHEAST1: 'asia-northeast1' as GCPRegionsEnum,

    ASIA_SOUTH1: 'asia-south1' as GCPRegionsEnum,

    ASIA_SOUTH2: 'asia-south2' as GCPRegionsEnum,

    AUSTRALIA_SOUTHEAST1: 'australia-southeast1' as GCPRegionsEnum,

    ME_WEST1: 'me-west1' as GCPRegionsEnum,

    NORTHAMERICA_NORTHEAST1: 'northamerica-northeast1' as GCPRegionsEnum,

    NORTHAMERICA_NORTHEAST2: 'northamerica-northeast2' as GCPRegionsEnum,

    SOUTHAMERICA_EAST1: 'southamerica-east1' as GCPRegionsEnum,

    SOUTHAMERICA_WEST1: 'southamerica-west1' as GCPRegionsEnum
};

